export default {
  name: "Minimum Job Qualifications/Requirements",
  prefix: "B",
  sections: [
    {
      fields: [
        {
          isGroup: {
            code: "B.1",
            label: "Education: minimum U.S. diploma/degree required.",
            machine_name: "eta_790a_b1_education_level",
            tooltip:
              'If a minimum U.S. diploma or degree is required to perform the agricultural services or labor, select the option that identifies the requirement. If no minimum U.S. diploma or degree is required, select "<strong>NONE</strong>". Only mark one box.',
            coloring: "none",
            disabled: true,
            required: true,
            fields: [
              {
                widget: "radio",
                choice: "None",
                value: "none",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "High School/GED",
                value: "HS/GED",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Associate's",
                value: "associate",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Bachelor's",
                value: "bachelor",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Master's or Higher",
                value: "master",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "Other degree (JD, MD, etc.)",
                value: "other",
                validate: ["required"],
              },
            ],
          },
        },
        {
          code: "B.2",
          machine_name: "eta_790a_b2_experience_months",
          widget: "text",
          label: "Work Experience: number of <u>months</u> required.",
          validate: [
            "required",
            {
              fieldComparison: "eta_790a_b2_experience_months",
              message: "This number should be greater than or equal to 0.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumber",
          tooltip:
            'If a minimum amount of experience is required to perform the agricultural labor or services, indicate the amount of experience required in <u>months</u>.  If no minimum experience is required, enter "<strong>0</strong>" (zero). Information about the nature of the experience required may be disclosed in Item B.6.',
        },
        {
          code: "B.3",
          machine_name: "eta_790a_b3_training_months",
          widget: "text",
          label: "Training: number of <u>months</u> required.",
          validate: [
            "required",
            {
              fieldComparison: "eta_790a_b3_training_months",
              message: "This number should be greater than or equal to 0.",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 4,
          parse: "positiveWholeNumber",
          tooltip:
            'If a minimum amount of training is required to perform the agricultural labor or services, indicate the amount of training required in <u>months</u>.  If no minimum training is required, enter "<strong>0</strong>" (zero).  If less than one month of training is required, enter "<strong>0</strong>" (zero) in Item B.3 and provide the specific number of days or weeks of training required in Item B.6.  Information about the nature of the training required may be disclosed in Item B.6.  Note:  When answering this item, do not duplicate time requirements ― identify only the time required for the training identified in Item B.3. Do not include (add) time for the education or experience identified in Items B.1 and B.2.',
        },
        {
          isGroup: {
            code: "B.4",
            label: "Basic Job Requirements (check all that apply)",
            machine_name: "_b_4_job_requirements",
            tooltip: `Select the list of work tasks and requirements that are normally required to perform the agricultural labor or services.
              Check all that apply. Information about the nature of the work tasks and requirements checked may be disclosed in Item
              B.6. For example, if “Certification/license requirements” applies, use Item B.6 to specify the certification(s) and/or
              license(s) required (e.g., commercial driver’s license). Similarly, if “Driver requirements” applies, use Item B.6 to describe
              nature of the driving requirements, such as the farm equipment involved (e.g., self-propelled custom class combine) or
              whether a clean driving record is required to drive grain and transporter trucks. If “Extensive sitting or walking” is
              checked, use Item B.6 to explain the nature of the siting or walking required.`,
            coloring: "none",
            disabled: true,
            columns: true,
            fields: [
              {
                machine_name: "eta_790a_b4a_certification_req",
                widget: "checkbox_old",
                choice: "Certification/license requirements",
                label: "Certification/license requirements",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4b_driver_req",
                widget: "checkbox_old",
                choice: "Driver requirements",
                label: "Driver requirements",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4c_background_req",
                widget: "checkbox_old",
                choice: "Criminal background check",
                label: "Criminal background check",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4d_drug_screen_req",
                widget: "checkbox_old",
                choice: "Drug Screen",
                label: "Drug Screen",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4e_lifting_req",
                widget: "checkbox_old",
                choice: "Lifting requirements",
                label: "Lifting requirements",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4g_temperature_req",
                widget: "checkbox_old",
                choice: "Exposure to extreme temperatures",
                label: "Exposure to extreme temperatures",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4h_pushing_req",
                widget: "checkbox_old",
                choice: "Extensive pushing or pulling",
                label: "Extensive pushing or pulling",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4i_walking_req",
                widget: "checkbox_old",
                choice: "Extensive sitting or walking",
                label: "Extensive sitting or walking",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4j_bending_req",
                widget: "checkbox_old",
                choice: "Frequent stooping or bending over",
                label: "Frequent stooping or bending over",
                value: "YES",
                hidden: true,
              },
              {
                machine_name: "eta_790a_b4k_rep_motion_req",
                widget: "checkbox_old",
                choice: "Repetitive movements",
                label: "Repetitive movements",
                value: "YES",
                hidden: true,
              },
            ],
          },
        },
        {
          code: "B.4.E",
          machine_name: "eta_790a_b4f_lifting_lbs",
          widget: "text",
          label: "How much weight in pounds is the lifting requirement?",
          validate: [
            "required",
            {
              fieldComparison: "eta_790a_b4f_lifting_lbs",
              message: "This number should be greater than or equal to 0",
              needsFieldValues: true,
              extraData: {
                operator: ">=",
                valueOf: 0,
              },
            },
          ],
          maxLength: 3,
          isVisible: {
            when: "eta_790a_b4e_lifting_req",
            is: "YES",
          },
          parse: "positiveNumber",
        },
        {
          isGroup: {
            code: "B.5.A",
            label:
              "Supervision: does this position supervise the work of other employees?",
            machine_name: "eta_790a_b5a_is_supervising",
            tooltip:
              "<ul><li>Mark “Yes” or “No” as to whether the job opportunity supervises the work of other employees.</li><li>If “Yes” is marked in question 5a, enter the total number of employees the job opportunity will supervise.</li></ul>",
            coloring: "none",
            required: true,
            disabled: true,
            fields: [
              {
                widget: "radio",
                choice: "Yes",
                value: "YES",
                validate: ["required"],
              },
              {
                widget: "radio",
                choice: "No",
                value: "NO",
                validate: ["required"],
                clearSchema: ["eta_790a_b5b_num_supervised"],
              },
            ],
          },
        },
        {
          code: "B.5.B",
          machine_name: "eta_790a_b5b_num_supervised",
          widget: "text",
          label: "Number of employees worker will supervise:",
          maxLength: 4,
          validate: ["required"],
          parse: "positiveWholeNumber",
          isVisible: {
            when: "eta_790a_b5a_is_supervising",
            is: "YES",
          },
        },
      ],
    },
    {
      divider: "hide",
      fields: [
        {
          code: "B.6",
          machine_name: "eta_790a_b6_additional_info",
          widget: "text_area",
          label: `
            Additional Information Regarding Job Qualifications/Requirements.
            <br/>
            <br/>
            <em>(A response must begin in the space provided below on this form. Use <strong>Addendum C</strong> if additional space is needed. If no additional skills or requirements, enter “<b><u>NONE</u></b>” below)</em>`,
          validate: [
            "required",
            {
              fieldComparison: "eta_790a_b6_additional_info",
              message:
                'Enter a full statement containing the additional information regarding job qualifications/requirements or "NONE".',
              needsFieldValues: true,
              extraData: {
                operator: "minLength",
                valueOf: 4,
              },
            },
            {
              fieldArrayContainsValue: "Job Qualifications/Requirements",
              needsFieldValues: true,
              message: `An Addendum C entry is only allowed once B.6 Job Qualifications/Requirements has reached at least 800 characters. Please either remove the Addendum C entry or add additional information into B.6 Job Qualifications/Requirements.`,
              extraData: {
                fieldArray: "eta_790a_addendum_c",
                fieldToCheck: "section_number",
                onlyIf: 800,
                operator: "<",
                shouldContainValue: false,
              },
            },
          ],
          width: 8,
          rows: 10,
          inputLimit: 1000,
          info: {
            text: "<em>Important Note</em>: The response to this item must begin in this section of the form and <strong>Addendum C</strong> may be used ONLY if more space is needed. You must begin your response in this section, with at <em>least 800 characters</em> entered - before the system will allow an <strong>Addendum C</strong> entry.",
            coloring: "grey",
            divider: false,
            css: {
              marginTop: 20,
              marginBottom: 10,
            },
          },
          tooltip:
            "Describe any other qualifications or requirements  to perform the agricultural labor or services, such as quantifiable lifting requirements, level of supervision and number of workers to supervise, and types of licenses or permits.  This item may also be used to provide more detailed information about the qualifications and/or requirements identified in Items B.1 through B.5.  If no additional qualifications or requirements are needed and no additional information about Items B.1 through B.5 is required, enter “<strong>NONE</strong>” in the space provided.  If additional space is required to fully disclose the qualification and requirement details for Item B.6, the employer may use only one (1) Addendum C of the Form ETA-790A.",
          addendumCInline: {
            display: true,
            header: "Job Qualifications/Requirements",
            addModalHeader: "+ Add on Addendum C",
          },
        },
      ],
    },
    {
      machine_name: "_add_addendum_c_job_requirements",
      maxAllowed: 1,
      coloring: "blue",
      isModal: true,
      sectionHeader:
        "Material Terms and Conditions - Job Qualifications/Requirements",
      openModalHeader: "Add Addendum C",
      modalHeader: "Add Material Terms and Conditions of the Job Offer",
      master_fieldArray: "eta_790a_addendum_c",
      listType: "inline",
      modalFields: [
        {
          machine_name: "section_number",
          label: "Section of Material Term or Condition",
          widget: "select",
          selection: [
            "Job Duties",
            "Overtime Pay",
            "Minimum Productivity/Performance Standards",
            "Job Qualifications/Requirements",
            "Provision of Meals",
            "Daily Transportation",
            "Inbound/Outbound Transportation",
            "Deductions from Pay",
            "Other Material Terms and Conditions",
          ],
          disabled: true,
          initialValue: "Job Qualifications/Requirements",
          validate: ["required"],
        },
        {
          machine_name: "section_name",
          label: "Summary of Material Term or Condition",
          widget: "text",
          disabled: true,
          initialValue: "Job Qualifications/Requirements",
          validate: [
            {
              minLength: 5,
              message:
                "Summary of Material Terms Conditions must contain at least 5 characters",
            },
          ],
          maxLength: 150,
        },
        {
          machine_name: "section_details",
          label: "Details of Material Term or Condition",
          widget: "text_area",
          rows: "8",
          inputLimit: 5000,
          validate: [
            "required",
            {
              minLength: 5,
              message:
                "Details of Material Term or Condition must contain at least 5 characters",
            },
          ],
        },
      ],
    },
  ],
};
